export const LogoUrl="//netflix-clone-ebon-nu.vercel.app/f4070143e1f521da82a119eb78b434d0.png"
export const HeroBannerUrl="https://assets.nflxext.com/ffe/siteui/vlv3/45082c39-e6d5-4b02-8867-e38fe32ed3af/4b49769b-ddbc-406a-a26b-482024a66727/IN-en-20220919-popsignuptwoweeks-perspective_alpha_website_large.jpg"
export const TopRatedUrl="https://api.themoviedb.org/3/movie/top_rated?api_key=d6d47f39c9fd13524ea9023dc82cd9c7"
export const NetflixOrginalsUrl="https://api.themoviedb.org/3/discover/tv?api_key=d6d47f39c9fd13524ea9023dc82cd9c7&with_networks=213"
export const trendingAllUrl="https://api.themoviedb.org/3/trending/all/week?api_key=d6d47f39c9fd13524ea9023dc82cd9c7"
export const popularMoviesUrl="https://api.themoviedb.org/3/movie/popular?api_key=d6d47f39c9fd13524ea9023dc82cd9c7"
export const movieGenres="https://api.themoviedb.org/3/genre/movie/list?api_key=d6d47f39c9fd13524ea9023dc82cd9c7&language=en-US"
export const moviesOnly="https://api.themoviedb.org/3/discover/movie?api_key=d6d47f39c9fd13524ea9023dc82cd9c7&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&with_watch_monetization_types=flatrate"
export const tvGenres="https://api.themoviedb.org/3/genre/tv/list?api_key=d6d47f39c9fd13524ea9023dc82cd9c7&language=en-US"
export const tvOnly="https://api.themoviedb.org/3/discover/tv?api_key=d6d47f39c9fd13524ea9023dc82cd9c7&language=en-US&sort_by=popularity.desc&include_null_first_air_dates=false&with_watch_monetization_types=flatrate&with_status=0&with_type=0"
export const searchUrl="https://api.themoviedb.org/3/search/multi?api_key=d6d47f39c9fd13524ea9023dc82cd9c7&language=en-US&include_adult=false"
export const list="http://localhost:4040/api/list"
export const serverUrl="https://netflixxcloneserver.herokuapp.com"
export const genre={
      28: "Action",
    12: "Adventure",
    16: "Animation",
    35: "Comedy",
    80: "Crime",
    99: "Documentary",
    18: "Drama",
    10751: "Family",
    14: "Fantasy",
    36: "History",
    27: "Horror",
    10402: "Music",
    9648: "Mystery",
    10749: "Romance",
    878: "Sci Fi",
    10770: "TV Movie",
    53: "Thriller",
    10752: "War",
    37: "Western",
    10759: " Adventure",
    10762: "Kids",
    10763: "News",
    10764: "Reality",
    10765: "Sci-Fi",
    10766: "Soap",
    10767: "Talk",
    10768: "War & Politics"
}